import { render, staticRenderFns } from "./index copy 3.vue?vue&type=template&id=32e7b9aa&scoped=true"
import script from "./index copy 3.vue?vue&type=script&lang=js"
export * from "./index copy 3.vue?vue&type=script&lang=js"
import style0 from "./index copy 3.vue?vue&type=style&index=0&id=32e7b9aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e7b9aa",
  null
  
)

export default component.exports